import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';
import { ChevronRight, Sparkles, MessageSquare } from 'lucide-react';

const ForumIntro = () => {
  const { t } = useLanguage();
  usePageTitle('Information');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-x-hidden">
      <section className="relative pt-28 pb-12 sm:pt-36 sm:pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-4 text-white flex items-center gap-2">
            <Sparkles className="h-6 w-6 sm:h-7 sm:w-7 text-accent flex-shrink-0" />
            {t('forumIntroPage.title')}
          </h1>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-8">
            {t('forumIntroPage.body')}
          </p>
          <div className="mx-auto max-w-xl rounded-xl overflow-hidden border border-dark-border bg-dark-card mb-8 shadow-lg">
            <img
              src="/images/forum-intro-categories.png"
              alt={t('forumIntroPage.image2Alt')}
              className="w-full h-auto object-contain bg-dark-surface"
            />
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/forum"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-accent font-medium text-sm rounded-full border border-accent/30 hover:bg-accent/10 transition-all duration-300"
            >
              <MessageSquare className="h-4 w-4" />
              {t('forumIntroPage.goToForum')} <ChevronRight className="h-4 w-4" />
            </Link>
            <Link
              to="/#projects"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-gray-300 font-medium text-sm rounded-full border border-white/[0.12] hover:bg-white/[0.06] hover:border-white/25 hover:text-white transition-all duration-300"
            >
              {t('forumIntroPage.backToProjects')} <ChevronRight className="h-4 w-4" />
            </Link>
            <Link
              to="/careers"
              className="shimmer-wrap inline-flex items-center gap-2 px-5 py-2.5 text-gray-300 font-medium text-sm rounded-full border border-white/[0.12] hover:bg-white/[0.06] hover:border-white/25 hover:text-white transition-all duration-300"
            >
              {t('footer.about.join')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForumIntro;
